import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams, generatePath } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import {
  SidePanel,
  SidePanelType,
  FooterContentPosition,
  ButtonPrimary,
  Popup,
} from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import { useUpdatePspPartnerMutation } from './store/services';
import PaymentTypesInput from '../../components/bank-and-psp/payment-types-input';

import { BankRoutes } from '../../routes';

import cn from './bank-and-psp.module.css';

const PaymentTypesSidepanel = () => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty },
  } = useForm();
  const [dirtyPopupVisible, setDirtyPopupVisible] = useState(false);

  const {
    info: { generalInfo },
    itemForm: { formValues },
  } = useAppSelector((state) => state.bankAndPsp);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { bankId } = useParams();

  const [update, { isLoading, isSuccess }] = useUpdatePspPartnerMutation();

  const onFormSubmit = handleSubmit(async (formValue) => {
    await update({
      id: bankId as string,
      body: {
        ...formValues,
        paymentsTypes: formValue.paymentsTypes,
      },
    });
  });

  const handleClose = useCallback(() => {
    setPanelIsOpen(false);

    setTimeout(() => {
      navigate(
        generatePath(BankRoutes.BANK_AND_PSP_INTEGRATION, {
          bankId: bankId as string,
        }),
      );
    }, 100);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      handleClose();
    }
  }, [isSuccess]);

  useEffect(() => {
    setPanelIsOpen(true);
  }, [dispatch]);

  useEffect(() => {
    if (generalInfo && bankId) {
      reset({ paymentsTypes: generalInfo.paymentsTypes });
    }
  }, [reset, generalInfo, bankId]);

  return (
    <>
      <SidePanel
        type={SidePanelType.Cards}
        closeOnClickOutside
        isOpen={panelIsOpen}
        onClose={isDirty ? () => setDirtyPopupVisible(true) : handleClose}
        title="Edit payment types"
        footerContentPosition={FooterContentPosition.Center}
        sidepanelExpandedKey="bank-payment-types"
        footer={
          <ButtonPrimary
            text={isLoading ? 'Loading...' : 'Save changes'}
            onClick={onFormSubmit}
            bold
          />
        }
      >
        <div className={cn.paymentTypesForm}>
          <div className={cn.paymetTypesFormTitle}>Select Payment Type:</div>
          <PaymentTypesInput control={control} />
        </div>
      </SidePanel>
      <Popup
        title="You have unsaved changes that will be lost"
        description="Are you sure you want to close this form?"
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={handleClose}
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
        parent={document.getElementById('dirty-popup') as HTMLElement}
      />
      <div id="dirty-popup" />
    </>
  );
};

export default PaymentTypesSidepanel;
